import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ebdbfda2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ReviewAnswerCardContainer wd100 brd2"
};
const _hoisted_2 = {
  class: "boldFont"
};
const _hoisted_3 = {
  class: "boldFont"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "boldFont"
}, "整体数据", -1));
const _hoisted_5 = {
  class: "ml16"
};
const _hoisted_6 = {
  key: 0,
  class: "ml16"
};
const _hoisted_7 = {
  key: 2,
  class: "reaction-summary"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "校正分", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "反应中位数", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "P90 反应时间", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "每分钟答对", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_13 = {
  class: "my-header"
};
const _hoisted_14 = {
  style: {
    "display": "inline-block",
    "padding-left": "30px"
  }
};
const _hoisted_15 = {
  class: "review-dialog__rank"
};
const _hoisted_16 = {
  class: "review-dialog__rank_label"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "review-rank-help",
  "aria-label": "了解当前作答评级"
}, "?", -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "看这一次，你答得怎么样", -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "只看本次答题成绩，不合并你以前的成绩。", -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createTextVNode("同题型已完成的答题记录"), /*#__PURE__*/_createElementVNode("strong", null, "少于 5 次"), /*#__PURE__*/_createTextVNode("时，按本次正确率评级；"), /*#__PURE__*/_createElementVNode("strong", null, "达到 5 次"), /*#__PURE__*/_createTextVNode("时，按本次正确题数在所有记录中的排名评级。同一个人多次答题，会算作多条记录。")], -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "review-rank-tip__rules"
}, [/*#__PURE__*/_createElementVNode("p", null, "按正确率：A ≥90%；B ≥75%；C ≥60%；低于 60% 为 D。未答题也计入总题数。"), /*#__PURE__*/_createElementVNode("p", null, "按排名：前 10% 为 A，接下来至前 30% 为 B，再至前 70% 为 C，其余为 D。")], -1));
const _hoisted_22 = {
  style: {
    "display": "inline-block",
    "padding-left": "50px"
  }
};
const _hoisted_23 = {
  class: "review-dialog__rank"
};
const _hoisted_24 = {
  class: "review-dialog__rank_label"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "review-rank-help",
  "aria-label": "了解历史综合评级"
}, "?", -1));
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "看长期，你的整体表现怎么样", -1));
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "综合你在这个题型的历史答题成绩，不只看本次。", -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createTextVNode("参与排名的用户"), /*#__PURE__*/_createElementVNode("strong", null, "少于 5 人"), /*#__PURE__*/_createTextVNode("时，按你的历史累计正确率评级；"), /*#__PURE__*/_createElementVNode("strong", null, "达到 5 人"), /*#__PURE__*/_createTextVNode("时，按你的平均正确题数在所有用户中的排名评级。每个人只占一个排名位置。")], -1));
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "review-rank-tip__rules"
}, [/*#__PURE__*/_createElementVNode("p", null, "按正确率：累计正确题数 ÷ 累计总题数（含未答）。A ≥90%；B ≥75%；C ≥60%；低于 60% 为 D。"), /*#__PURE__*/_createElementVNode("p", null, "按排名：前 10% 为 A，接下来至前 30% 为 B，再至前 70% 为 C，其余为 D。")], -1));
const _hoisted_30 = {
  class: "review-dialog__info"
};
const _hoisted_31 = {
  style: {
    "font-size": "24px",
    "font-weight": "500",
    "padding-bottom": "5px"
  }
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " ----------------------------------- ", -1));
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "当前考核为课堂作业/课后作业", -1));
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://sjxzc.oss-cn-beijing.aliyuncs.com/2025/07/24/cup.png",
  class: "review-dialog__img",
  alt: ""
}, null, -1));
const _hoisted_35 = {
  style: {
    "display": "inline-block",
    "width": "350px",
    "height": "300px",
    "margin-right": "5px"
  }
};
const _hoisted_36 = {
  style: {
    "display": "inline-block",
    "width": "350px",
    "height": "300px",
    "margin-right": "5px"
  }
};
const _hoisted_37 = {
  style: {
    "display": "inline-block",
    "width": "350px",
    "height": "300px",
    "margin-right": "5px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_testPieChart = _resolveComponent("testPieChart");
  const _component_numBarChart = _resolveComponent("numBarChart");
  const _component_accuracyBarChart = _resolveComponent("accuracyBarChart");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$props.showList ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [$props.groupSize == 1 ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "flex items-center justify-center"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_2, "共" + _toDisplayString($props.questions.length) + "题", 1)]),
    _: 1
  })) : (_openBlock(), _createBlock(_component_el_row, {
    key: 1,
    class: "flex items-center justify-center"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_3, "共" + _toDisplayString($props.questions.length) + "组,每组" + _toDisplayString($props.groupSize) + "题", 1)]),
    _: 1
  }))], 64)) : (_openBlock(), _createBlock(_component_el_row, {
    key: 1,
    class: "flex items-center justify-center"
  }, {
    default: _withCtx(() => [_hoisted_4]),
    _: 1
  })), _createVNode(_component_el_row, {
    class: "flex items-center justify-center ft14 mt8"
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, "正确" + _toDisplayString($props.questions.filter(q => q == 0).length), 1), _createElementVNode("span", _hoisted_5, "错误" + _toDisplayString($props.questions.filter(q => q == 1).length), 1), $props.showList ? (_openBlock(), _createElementBlock("span", _hoisted_6, "未答" + _toDisplayString($props.questions.filter(q => q == 2).length), 1)) : _createCommentVNode("", true)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex items-center justify-center ft14 mt8"
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, "正确率 " + _toDisplayString($options.accuracy) + "%", 1)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex items-center justify-center ft14 mt8"
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, "答题耗时:" + _toDisplayString($options.secondsToMMSS($props.costTime)), 1)]),
    _: 1
  }), $props.subject === 'DigitSymbolReaction' && $props.examResult && $props.examResult.reactionSummary ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", null, [_createElementVNode("strong", null, _toDisplayString($props.examResult.reactionSummary.adjustedScore), 1), _hoisted_8]), _createElementVNode("div", null, [_createElementVNode("strong", null, _toDisplayString($props.examResult.reactionSummary.medianReactionTimeMs) + " ms", 1), _hoisted_9]), _createElementVNode("div", null, [_createElementVNode("strong", null, _toDisplayString($props.examResult.reactionSummary.p90ReactionTimeMs) + " ms", 1), _hoisted_10]), _createElementVNode("div", null, [_createElementVNode("strong", null, _toDisplayString($props.examResult.reactionSummary.correctPerMinute), 1), _hoisted_11])])) : _createCommentVNode("", true), $props.showList ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 3
  }, [$props.groupSize == 1 ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "pd12",
    gutter: 10
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.questions, (q, qi) => {
      return _openBlock(), _createBlock(_component_el_col, {
        key: qi,
        span: 8,
        class: "flex items-center mb10"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          size: "small",
          onClick: $event => _ctx.$emit('goto', qi),
          class: _normalizeClass({
            'wd100 rightAnswer': q == 0,
            'wd100 wrongAnswer': q == 1,
            'wd100 missAnswer': q == 2
          })
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(qi + 1), 1)]),
          _: 2
        }, 1032, ["onClick", "class"])]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  })) : (_openBlock(), _createBlock(_component_el_row, {
    key: 1,
    class: "pd12",
    gutter: 10
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.questions.length / $props.groupSize, q => {
      return _openBlock(), _createBlock(_component_el_col, {
        span: 8,
        class: "flex items-center mb10",
        key: `review${q}`
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          size: "small",
          onClick: $event => _ctx.$emit('goto', q - 1),
          class: "wd100"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(q), 1)]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }))], 64)) : _createCommentVNode("", true), _createVNode(_component_el_button, {
    type: "success",
    class: "wd100 mt30",
    onClick: _cache[0] || (_cache[0] = $event => $data.dialogTableVisible = true)
  }, {
    default: _withCtx(() => [_createTextVNode("综合评价")]),
    _: 1
  }), _hoisted_12, _createVNode(_component_el_button, {
    type: "primary",
    class: "wd100",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.$router.go(-1))
  }, {
    default: _withCtx(() => [_createTextVNode("结束回看")]),
    _: 1
  }), _createVNode(_component_el_dialog, {
    class: "review-dialog",
    modelValue: $data.dialogTableVisible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.dialogTableVisible = $event),
    title: "",
    width: "1110"
  }, {
    header: _withCtx(({}) => [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: $options.isClassTest ? 7 : 9
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString($props.examResult ? $props.examResult.currentExamLevel : ''), 1), _createElementVNode("div", _hoisted_16, [_createTextVNode(" 当前作答评级 "), _createVNode(_component_el_popover, {
          placement: "bottom",
          width: 320,
          trigger: "hover",
          "popper-class": "review-rank-tip"
        }, {
          reference: _withCtx(() => [_hoisted_17]),
          default: _withCtx(() => [_hoisted_18, _hoisted_19, _hoisted_20, _hoisted_21]),
          _: 1
        })])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString($options.rank || '—'), 1), _createElementVNode("div", _hoisted_24, [_createTextVNode(" 历史综合评级 "), _createVNode(_component_el_popover, {
          placement: "bottom",
          width: 320,
          trigger: "hover",
          "popper-class": "review-rank-tip"
        }, {
          reference: _withCtx(() => [_hoisted_25]),
          default: _withCtx(() => [_hoisted_26, _hoisted_27, _hoisted_28, _hoisted_29]),
          _: 1
        })])])]),
        _: 1
      }, 8, ["span"]), _createVNode(_component_el_col, {
        span: $options.isClassTest ? 11 : 9
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_30, [_createElementVNode("p", _hoisted_31, _toDisplayString($data.infoMap[$props.subject].name), 1), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: $options.isClassTest ? 13 : 24,
            style: _normalizeStyle($options.isClassTest ? {
              color: '#FFD700'
            } : {
              color: _ctx.white
            })
          }, {
            default: _withCtx(() => [_createElementVNode("p", null, " 综合成绩在系统用户中排名：" + _toDisplayString($data.subjectData.rightRank + 1), 1), _createElementVNode("p", null, " 参与排名的用户总数：" + _toDisplayString($data.subjectData.rankUserCnt), 1), _hoisted_32, _createElementVNode("p", null, " 本次答题在平台所有答题中排名：" + _toDisplayString($props.examResult ? $props.examResult.currentExamRank : ''), 1), _createElementVNode("p", null, " 平台历史答题总次数：" + _toDisplayString($props.examResult ? $props.examResult.currentExamRankUserCnt : ''), 1)]),
            _: 1
          }, 8, ["span", "style"]), $options.isClassTest ? (_openBlock(), _createBlock(_component_el_col, {
            key: 0,
            span: 11,
            style: {
              "color": "#3269FF"
            }
          }, {
            default: _withCtx(() => [_hoisted_33, _createElementVNode("div", null, "您此次成绩在课堂中的排名：" + _toDisplayString($data.rankNo), 1), _createElementVNode("div", null, "您的课堂总人数：" + _toDisplayString($data.classTotal), 1), _createElementVNode("div", null, "课堂中参与排名人数：" + _toDisplayString($data.doneNum), 1)]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })])]),
        _: 1
      }, 8, ["span"]), _createVNode(_component_el_col, {
        span: 6
      }, {
        default: _withCtx(() => [_hoisted_34]),
        _: 1
      })]),
      _: 1
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_35, [$options.testData ? (_openBlock(), _createBlock(_component_testPieChart, {
      key: 0,
      data: $options.testData
    }, null, 8, ["data"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_36, [$options.testData ? (_openBlock(), _createBlock(_component_numBarChart, {
      key: 0,
      data: [$options.rightAnswer, $data.subjectData.averageRight?.toFixed(2), $options.allUserAveRight],
      total: $options.total
    }, null, 8, ["data", "total"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_37, [$options.testData ? (_openBlock(), _createBlock(_component_accuracyBarChart, {
      key: 0,
      data: [$options.accuracy, $options.averageRightAccuracy, $options.allUserAverageRightAccuracy]
    }, null, 8, ["data"])) : _createCommentVNode("", true)])]),
    _: 1
  }, 8, ["modelValue"])]);
}